var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelinesSidebar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5.75V4.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.75V4.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 5.75V4.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 7.25H19.25"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.75,
    width: 16,
    height: 13.75,
    rx: 2.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.25H16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.25H12.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 16.9,
    r: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2 15.55V16.95L18.1 17.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelinesSidebar);
export default __webpack_public_path__ + "static/media/timelinesSidebar.b474d6a5b4809297ff43c9b433c72c68.svg";
export { ForwardRef as ReactComponent };